export const RECEIVING_INVOICE_STATUS_OPEN = "open";
export const RECEIVING_INVOICE_STATUS_CLOSED = "closed";

export const receivingInvoiceStatusOptions = [
  {
    value: RECEIVING_INVOICE_STATUS_OPEN,
    label: "Open",
    type: "success",
  },
  {
    value: RECEIVING_INVOICE_STATUS_CLOSED,
    label: "Closed",
    type: "gray",
  },
];

export function normalizeReceivingInvoiceStatus(status: unknown): string {
  const raw =
    status != null && typeof status === "object" && "value" in status
      ? (status as { value: unknown }).value
      : status;

  return raw === RECEIVING_INVOICE_STATUS_CLOSED
    ? RECEIVING_INVOICE_STATUS_CLOSED
    : RECEIVING_INVOICE_STATUS_OPEN;
}

export function receivingInvoiceStatusOption(status: unknown) {
  const code = normalizeReceivingInvoiceStatus(status);

  return (
    receivingInvoiceStatusOptions.find((option) => option.value === code) ??
    receivingInvoiceStatusOptions[0]
  );
}

export function receivingInvoiceStatusPill(status: unknown) {
  const option = receivingInvoiceStatusOption(status);

  return { text: option.label, type: option.type };
}
